export const federalTaxClassifications = [
  {
    name: 'Individual/sole proprietor or single-member LLC',
    type: 'individual',
  },
  {
    name: 'C Corporation',
    type: 'ccorp',
  },
  {
    name: 'S Corporation',
    type: 'scorp',
  },
  {
    name: 'Partnership',
    type: 'partnership',
  },
  {
    name: 'Trust/estate',
    type: 'trust',
  },
  {
    name: 'Limited liability company',
    type: 'llc',
  },
  {
    name: 'Other',
    type: 'other',
  },
];
